"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    method: 'GET',
    credentials: 'same-origin',
    noparse: undefined,
    headers: {
        'Accept': 'application/json, */*',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    }
};
exports.default = defaultOptions;
//# sourceMappingURL=default.js.map